import script from "./AppToolbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppToolbar.vue?vue&type=script&lang=ts&setup=true"

import "./AppToolbar.vue?vue&type=style&index=0&id=37b346f6&lang=scss&scoped=true"
script.__scopeId = "data-v-37b346f6"

export default script
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToolbar,QToolbarTitle});
